import React, { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const SidebarContext = createContext();

export const useSidebar = () => {
  const [showReportsNav, setShowReportsNav] = useState(false);
  const [dashboardActice, setDashboardActive] = useState(true);
  const [showLeadsNav, setShowLeadsNav] = useState(false);
  const [showSettingsNav, setShowSettingsNav] = useState(false);
  const [showAutomationsNav, setShowAutomationsNav] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/smartview" || pathname === "/manageLeads" || pathname === "/deleteLeads") {
      setShowLeadsNav(true);
    }
    if (
      pathname === "/manageUsers" ||
      pathname === "/user-permissions" ||
      pathname === "/requesthistory"
    ) {
      setShowSettingsNav(true);
    }
    if (pathname === "/reports-payments") {
      setShowReportsNav(true);
    }

    if (pathname === "/wtemplates" || pathname === "/psmautomation" || pathname === "/churnautomation") {
      setShowAutomationsNav(true);
    }
  }, [pathname]);

  const toggleDashboard = () => {
    setDashboardActive(true);
    setShowSettingsNav(false);
    setShowLeadsNav(false);
    setShowReportsNav(false);
    setShowAutomationsNav(false);
  };

  const toggleShowLeadsNav = () => {
    setShowLeadsNav(!showLeadsNav);
    setDashboardActive(false);
    // if(showSettingsNav || showReportsNav) {
    setShowSettingsNav(false);
    setShowReportsNav(false);
    setShowAutomationsNav(false);
    // }
  };

  const toggleShowSettingsNav = () => {
    setShowSettingsNav(!showSettingsNav);
    setDashboardActive(false);
    setShowReportsNav(false);
    // if(showLeadsNav) {
    setShowLeadsNav(false);
    setShowAutomationsNav(false);
    // }
  };

  const toggleShowReportsNav = () => {
    setShowReportsNav(!showReportsNav);
    setDashboardActive(false);
    setShowLeadsNav(false);
    setShowSettingsNav(false);
    setShowAutomationsNav(false);
  };

  const toggleAutomationsNav = () => {
    setShowAutomationsNav(!showAutomationsNav);
    setDashboardActive(false);
    setShowSettingsNav(false);
    setShowLeadsNav(false);
    setShowReportsNav(false);
  };

  return {
    showLeadsNav,
    showSettingsNav,
    showReportsNav,
    toggleShowLeadsNav,
    toggleShowSettingsNav,
    toggleDashboard,
    toggleShowReportsNav,
    toggleAutomationsNav,
    showAutomationsNav,
  };
};

export const SidebarProvider = ({ children }) => {
  const sidebar = useSidebar();

  return (
    <SidebarContext.Provider value={sidebar}>
      {children}
    </SidebarContext.Provider>
  );
};
